// "What do I do next" copy for the two audiences a report reaches — a
// Portfolio Manager (budget/roadmap/vendor framing) and a Security Engineer
// (technical/control-implementation framing) — per framework control.
//
// Authored, not templated: content/report/role-actions/*.ts, one file per
// control, mirroring content/explanations/maturity/*.ts's pattern. Not every
// control is authored yet — getRoleActions() falls back to a generated
// statement built from data already on the recommendation, so the feature
// isn't blocked on finishing all 16 up front. `pnpm content:lint` warns
// (doesn't fail) on any control missing authored copy — see scripts/content-lint.ts.

// No authored per-control copy is ported into the toolbox, so this is always
// empty and getRoleActions() always uses the generated fallback below.
import type { RoleActions } from "../shared/types";

const roleActionsContent: Record<string, RoleActions> = {};

export type RoleView = "portfolioManager" | "securityEngineer";

export type RoleActionsContext = {
  controlId: string;
  controlName: string;
  domainLabel: string;
  targetLabel: string;
  rank: number;
  firstActionStep?: string;
};

export function hasAuthoredRoleActions(controlId: string): boolean {
  return controlId in roleActionsContent;
}

export function getRoleActions(ctx: RoleActionsContext): RoleActions {
  const authored = roleActionsContent[ctx.controlId];
  if (authored) return authored;
  return {
    portfolioManager: `Fund and prioritize closing the "${ctx.controlName}" gap (${ctx.domainLabel}) in the next planning cycle — it's ranked #${ctx.rank} by risk reduction in this assessment.`,
    securityEngineer: `Implement ${ctx.controlName} up to ${ctx.targetLabel}${
      ctx.firstActionStep ? `: ${ctx.firstActionStep}` : " — see the framework's level criteria for this control"
    }.`,
  };
}
